import React, { useEffect } from 'react';
import { Dropdown, Grid, Icon, Popup, List, Radio, Button, Menu, Label, Loader } from 'semantic-ui-react';
import { Link, NavLink, withRouter } from 'react-router-dom';
import axios from 'axios';
import { FormattedMessage } from 'react-intl';
import { IntlConsumer } from '../../IntlContext';
import moment from 'moment';
import { FiltersOnStyle } from '../../views/Professor/ProfessorInputGrades/css';
import ReactCountryFlag from 'react-country-flag';
import { toast, ToastContainer } from 'react-toastify';
import { keycloakLogoutUrl } from '../../util/keycloakClient';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

window.$setLanguageFirstTime = false;

const NOTIFICATION_POLL_MS = 1800000;
// The bell popup shows at most this many unread; if there are more we show "20+".
const POPUP_LIMIT = 20;


class Header extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activeRole: this.props.activeRole,
            allRoles: [],
            newNotifications: [],
            notifLoaded: false,
            openedIds: [],
            popupOpen: false,
            hasMoreNew: false,

            // notification
            seen: true,
            showNotificationNumber: true,
            allNotificationButton: true,


            // web push
            // denied: Notification.permission === 'denied',
            subscribed: false,
            publicKey: '',
            eventSource: null
        };
        // this.urlB64ToUint8Array = this.urlB64ToUint8Array.bind(this);
        // this.subscribe = this.subscribe.bind(this);
        // this.unsubscribe = this.unsubscribe.bind(this);
        this.markAllAsRead = this.markAllAsRead.bind(this);
        this.fetchNewNotification = this.fetchNewNotification.bind(this);
        this.markSeen = this.markSeen.bind(this);
        this.fetchAllRoles = this.fetchAllRoles.bind(this);
        this.connectToNotificationStream = this.connectToNotificationStream.bind(this);
        this.disconnectFromNotificationStream = this.disconnectFromNotificationStream.bind(this);
    }


    componentDidMount() {
        // this.fetchActiveRole();
        this.fetchAllRoles();
        this.fetchNewNotification();
        this.notifPoll = setInterval(this.fetchNewNotification, NOTIFICATION_POLL_MS);
    }

    componentWillUnmount() {
        clearInterval(this.notifPoll);
        this.disconnectFromNotificationStream();
    }

    // Poll for unread notifications for the bell (fast, unread-only endpoint).
    // While the popup is open we skip the periodic refresh so items the user is
    // reading don't disappear mid-read; the popup forces a refresh on close.
    fetchNewNotification(force) {
        if (this.state.popupOpen && !force) {
            return;
        }
        // Fetch one more than we show so we can tell whether there are 20+.
        axios.get('/notifications/user/unread?limit=' + (POPUP_LIMIT + 1))
            .then(res => {
                const all = Array.isArray(res.data) ? res.data : [];
                const hasMoreNew = all.length > POPUP_LIMIT;
                const newNotifications = all.slice(0, POPUP_LIMIT);
                this.setState({ newNotifications, hasMoreNew, notifLoaded: true });
            })
            .catch(() => {
                // Silent: a failed poll should not disrupt the UI
                this.setState({ notifLoaded: true });
            });
    }

    // Mark one notification as read on the server. Does NOT refetch — the item
    // stays visible/expanded in the popup until the popup is closed.
    markSeen(id) {
        axios.put('notifications/change-seen-status/', [id]).catch(() => {});
    }

    connectToNotificationStream() {
        if (this.state.eventSource) {
            return;
        }

        const baseURL = axios.defaults.baseURL || '';
        const eventSource = new EventSource(`${baseURL}/notifications/user/stream`, {
            withCredentials: true
        });

        eventSource.onmessage = (event) => {
            try {
                const notification = JSON.parse(event.data);
               // console.log('Parsed notification via SSE:', notification);
                // Add new notification to the beginning of the list
                this.setState(prevState => ({
                    newNotifications: [notification, ...prevState.newNotifications]
                }));
            } catch (error) {
                console.error('Error parsing SSE notification:', error);
            }
        };

        eventSource.onerror = (error) => {
            console.error('SSE connection error:', error);
            setTimeout(() => {
                console.log('Attempting to reconnect to notification stream...');
                this.setState({ eventSource: null });
                this.connectToNotificationStream();
            }, 5000);
        };

        eventSource.onopen = () => {
            console.log('SSE connection established');
        };

        this.setState({ eventSource });
    }

    disconnectFromNotificationStream() {
        if (this.state.eventSource) {
            this.state.eventSource.close();
            this.setState({ eventSource: null });
            console.log('SSE connection closed');
        }
    }


    /*fetchNewNotification() {
        this.setState({ loading: true });
        axios.get('/notifications/user/')
            .then(res => {
                const newNotifications = res.data.reverse();

                this.setState({ newNotifications, loading: false });
                // localStorage.setItem('newNotifications', JSON.stringify(newNotifications));
            })
            .catch(err => {
                console.log('Failed to fetch new notifications.');
            });
    }*/

    // unsubscribe() {
    //     navigator.serviceWorker.getRegistration()
    //         .then((registration)=>{
    //             registration.pushManager.getSubscription()
    //                 .then((subscription)=>{
    //                     subscription.unsubscribe()
    //                         .then(()=> {
    //                             axios.post('/notifications/unsubscribe', JSON.stringify(subscription.endpoint))
    //                                 .then(response => {
    //                                     this.setState({ subscribed: false });
    //                                 })
    //                         })
    //                 })
    //                 .catch((err)=> {
    //                     console.log('Unsubscribe failed. No subscription. ', err)
    //                 })
    //         })
    //         .catch((err)=> {
    //             console.log('No sw registration. ', err)
    //     })
    // }

    // subscribe() {
    //     Notification.requestPermission()
    //         .then(notificationPermission => {
    //             if (notificationPermission === 'granted') {
    //                 navigator.serviceWorker.getRegistration()
    //                     .then((registration) => {
    //                         registration.pushManager.getSubscription()
    //                             .then((subscription)=>{
    //                                 console.log('Provjera da li postoji subskripcija vec ', subscription);
    //                                 if (subscription === null){
    //                                     this.getPublicKey().then((publicKey)=>
    //                                         {
    //                                             this.setState({ publicKey},
    //                                                 ()=> {
    //                                                     registration.pushManager.subscribe({
    //                                                         userVisibleOnly: true,
    //                                                         applicationServerKey: this.urlB64ToUint8Array(publicKey), })
    //                                                         .then(subscription => {
    //                                                             const subJSObject = JSON.parse(JSON.stringify(subscription));
    //
    //                                                             axios.post('/notifications/subscribe', {endpoint: subscription.endpoint, keys: subJSObject.keys})
    //                                                                 .then(response => {
    //                                                                     this.setState({ subscribed: true });
    //                                                                 })
    //                                                         }, (err) => {
    //                                                             console.log('Subscription failed. ', err);
    //                                                         })
    //
    //                                                 })
    //
    //                                         }
    //                                     )
    //                                 } else {
    //                                     const subJSObject = JSON.parse(JSON.stringify(subscription));
    //                                     axios.post('/notifications/subscribe', {endpoint: subscription.endpoint, keys: subJSObject.keys})
    //                                         .then(response => {
    //                                             this.setState({ subscribed: true });
    //                                         })
    //                                 }
    //                                 this.setState({ subscribed: subscription });
    //                             })
    //
    //                 }, (err) => {
    //                     console.log('No sw registration. ', err);
    //                 });
    //             } else {
    //                 console.log('Permission denied! ');
    //                 this.setState({ denied: true });
    //             }
    //         });
    //
    // }

    // getPublicKey = () => axios.get('/notifications/get-public-key').then(response => response.data).catch(error => {console.error('Failed to fetch public key!');});

    // urlB64ToUint8Array(base64String) {
    //     const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
    //     const base64 = (base64String + padding)
    //         .replace(/\-/g, '+')
    //         .replace(/_/g, '/');
    //     const rawData = window.atob(base64);
    //     const outputArray = new Uint8Array(rawData.length);
    //     for (let i = 0; i < rawData.length; ++i) {
    //         outputArray[i] = rawData.charCodeAt(i);
    //     }
    //     return outputArray;
    // }

    // sendNotification(){
    //     navigator.serviceWorker.getRegistration().then((res) => {
    //         res.showNotification('Uspješno ste omogućili obavijesti na svom profilu.')
    //     })
    // }

    fetchActiveRole() {
        localStorage.remove('activeRole');
        axios.get('/user/current')
            .then(response => {
                this.setState({ activeRole: response.data });
                localStorage.setItem('activeRole', response.data);
            }).catch(error => {
            // TODO amel: error handling
                console.error('Failed to fetch active userrole');
            });
    }

    markAllAsRead() {
        this.setState({ loading: true });
        axios.put('notifications/mark-all-as-read/')
            .then(() => {
                this.setState({ loading: false });
                this.fetchNewNotification();
            })
            .catch(() => {
                this.setState({ loading: false });
                toast('Došlo je do greške!');
            });
    }

    fetchAllRoles() {
        axios.get('/user/all')
            .then(response => {
                this.setState({ allRoles: response.data });
            }).catch(error => {
                // TODO amel: error handling
                console.error('Failed to fetch user roles');
            });
    }

    sidebarToggle(e) {
        e.preventDefault();
        document.body.classList.toggle('sidebar-hidden');
    }

    sidebarMinimize(e) {
        e.preventDefault();
        document.body.classList.toggle('sidebar-minimized');
    }

    mobileSidebarToggle(e) {
        e.preventDefault();
        document.body.classList.toggle('sidebar-mobile-show');
    }

    asideToggle(e) {
        e.preventDefault();
        document.body.classList.toggle('aside-menu-hidden');
    }
    render() {
        const role = this.props.activeRole;

        let pdfLink = null;

        if (role && role.startsWith('HR admin: Rektorat')) {
            pdfLink = 'https://drive.google.com/drive/folders/1aGEeqGOdrDSDFxIM4lC4Nm2YIK49OyOo?usp=sharing';
        } else if (role && role.startsWith('HR admin - OJ')) {
            pdfLink = 'https://drive.google.com/drive/folders/10wNdiyT8lYX2SlmENlFtXg70XFuzMwkc?usp=sharing';
        } else if (role && (role.startsWith('Profesor') || role.startsWith('Asistent'))) {
            pdfLink = 'https://drive.google.com/drive/folders/1L_hnF5kKQeEJybI-uRZGoaBtlxTRwd2j?usp=drive_link';
        } else if (role && role.includes('saradnju')) {
            pdfLink = 'https://drive.google.com/drive/folders/1Cu907q6l4q4xxGpjsCPpWwaMAw-TAbts?usp=sharing';
        } else if (role && role.startsWith('Studentska')) {
            pdfLink = 'https://drive.google.com/drive/folders/1S0Xca59AZyNBL7v9KCboIpyPtZrhO4dL?usp=sharing';
        } else if (role && role.includes('QA admin - OJ')) {
            pdfLink = 'https://drive.google.com/drive/folders/1FbDIs3pzXGDOGqvkdKyxTCP-XAxHQwvq?usp=sharing';
        } else if (role && role.includes('QA admin:')) {
            pdfLink = 'https://drive.google.com/drive/folders/1-X-CTRmgVMZ5teaNwi-9o2VpfnV4f3Kv?usp=sharing';
        } else if (role && (role.startsWith('Student:') || role.includes('student:'))) {
            pdfLink = 'https://drive.google.com/drive/folders/1gicOU_NC63CocAl7z9vFiomTJLd38-v2?usp=sharing';
        } else if (role && role.includes('za nastavu')) {
            pdfLink = 'https://drive.google.com/drive/folders/1ZAwwed8lYWB0xsAjs6_C4yAHT4C6EtPs?usp=sharing';
        } else if (role && role.includes('kvaliteta')) {
            pdfLink = 'https://drive.google.com/drive/folders/1sUubBbQmzYxnHL5PZs6fIarVN_MwO201?usp=sharing';
        } else if (role && role.startsWith('Administrator')) {
            pdfLink = 'https://drive.google.com/drive/folders/1brNirnEvI5uJo8Ix5GGZWkdQTdMFg7f9?usp=sharing';
        } else if (role && role.startsWith('AIDA')) {
            pdfLink = 'https://drive.google.com/drive/folders/1lzoUzKK05diigMJY9UN9Y0YNt87AKSpR?usp=sharing';
        }


        return (
            <header className={window.location.href.includes('dev1.eunsa.ba') ? 'app-header navbar dev' : 'app-header navbar prod'} style={{ position: 'fixed' }}>


                {/* <Radio toggle checked={this.state.subscribed}   onChange={this.toggle} /> */}
                <button className="navbar-toggler mobile-sidebar-toggler d-lg-none" style={{ color: 'white', outline: 'none' }} onClick={this.mobileSidebarToggle} type="button">
                    &#9776;
                </button>

                <a className="navbar-brand d-md-down-none" href="/" />
                <a className="navbar-brand d-lg-none" href="/" />

                <ul className="nav navbar-nav d-md-down-none mr-auto">
                    <li className="nav-item">
                        <a className="nav-link navbar-toggler sidebar-toggler" onClick={this.sidebarToggle} style={{ color: 'white' }} href="/">&#9776;</a>
                    </li>
                </ul>


                <div style={{ float: 'right', right: '1%' }}>
                    <Grid columns={4} padded >

                        <Grid.Column>
                            <Dropdown
                                icon={<Icon name="info circle" color="grey" size="large" />}
                                direction="right"
                                pointing="top right"
                            >
                                <Dropdown.Menu style={{ padding: 0, minWidth: '220px' }}>
                                    {pdfLink && (
                                        <Dropdown.Item
                                            as="a"
                                            href={pdfLink}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={{
                                                margin: 0,
                                                borderRadius: 0,
                                                padding: '12px 16px'
                                            }}
                                        >
                                            <Icon name="external alternate" />
                                            <FormattedMessage id="common.systemUserGuide" />
                                        </Dropdown.Item>
                                    )}

                                    <Dropdown.Divider style={{ margin: 0 }} />

                                    <FormattedMessage id="route.faq">
                                        {(link) => (
                                            <Dropdown.Item
                                                as={NavLink}
                                                to={role.startsWith('Administrator') ? '/faq' : link}
                                                style={{
                                                    margin: 0,
                                                    borderRadius: 0,
                                                    padding: '12px 16px'
                                                }}
                                            >
                                                <Icon name="help" />
                                                FAQ
                                            </Dropdown.Item>
                                        )}
                                    </FormattedMessage>
                                </Dropdown.Menu>
                            </Dropdown>
                        </Grid.Column>

                        <Grid.Column only="computer">
                            {
                                (this.props.activeRole.substr(0, 8) === 'Student:' ||
                                    this.props.activeRole.substr(0, 10) === 'Studentska' ||
                                    this.props.activeRole.substr(0, 20) === 'Diplomirani student:' ||
                                    this.props.activeRole.substr(0, 16) === 'Ispisan student:' ||
                                    this.props.activeRole.substr(0, 8) === 'Profesor' ||
                                    this.props.activeRole.substr(0, 8) === 'Asistent')
                                    ?


                                        <Popup
                                        only="computer"
                                        size="mini"
                                        hideOnScroll={this.state.newNotifications.filter((e) => !e.seen).length === 0}
                                        flowing
                                        onClose={() => this.setState({ showNotificationNumber: true, popupOpen: false, openedIds: [] }, () => this.fetchNewNotification(true))}
                                        onOpen={() => { this.setState({ showNotificationNumber: false, popupOpen: true }, () => this.fetchNewNotification(true)); }}
                                        trigger={

                                            <div style={{ float: 'left', cursor: 'pointer' }}>


                                                {this.state.newNotifications.filter((e) => !e.seen).length !== 0 && this.state.showNotificationNumber
                                                    ?

                                                        <Icon.Group size="large">
                                                        <Icon name="bell" color="grey" />
                                                        <Label color="red" floating size="tiny" circular>
                                                                {this.state.hasMoreNew ? POPUP_LIMIT + '+' : this.state.newNotifications.filter((e) => !e.seen).length }
                                                            </Label>
                                                    </Icon.Group>
                                                    :
                                                    <Icon.Group size="large">
                                                            <Icon name="bell" color="grey" />
                                                            <Icon corner="bottom right" circular as="label"></Icon>
                                                        </Icon.Group>
                                                    // <Icon size="large" name="bell" color="grey" />
                                                }

                                            </div>
                                        }

                                        content={
                                            // <Link to={{ pathname: '/obavijesti' }} style={{ color: 'black' }}>

                                            <div style={{
                                                maxWidth: '20vw', width: '20vw', maxHeight: '500px', display: 'flex', flexDirection: 'column'
                                            }}
                                            >
                                            <div style={{ overflowY: 'auto', flex: 1 }}>
                                            {!this.state.notifLoaded ?
                                                <div style={{ textAlign: 'center', padding: '14px' }}>
                                                        <Loader active inline="centered" size="small" />
                                                    </div> :
                                                this.state.newNotifications.filter((e) => !e.seen).length === 0 ?
                                                <div >
                                                        <h5><FormattedMessage id="common.noNewNotifications" /></h5>

                                                    </div> :
                                                    <div>

                                                    <Label basic color="blue" as="a" onClick={(e) => { e.preventDefault(); this.markAllAsRead(); }} style={{ cursor: 'pointer' }}>
                                                            <Icon name="envelope open outline" />
                                                            <FormattedMessage id="common.markAllAsRead" />
                                                        </Label>
                                                    <Menu size="mini" vertical fluid divided relaxed style={{ marginBottom: '12px' }}>
                                                            {this.state.newNotifications.map((el) =>
                                                                (!el.seen && <Menu.Item
                                                                    key={el.id}
                                                                    active={this.state.openedIds.includes(el.id)}
                                                                    style={{ cursor: 'pointer' }}
                                                                    onClick={() => {
                                                                        if (this.state.openedIds.includes(el.id)) { return; }
                                                                        this.setState(prev => ({ openedIds: [...prev.openedIds, el.id] }));
                                                                        this.markSeen(el.id);
                                                                    }}
                                                                >
                                                                    <List.Content>
                                                                        <List.Header as="h4" style={{ color: '#1a6aa5' }}>
                                                                            {el.notification ? el.notification.subject : 'Nema teksta.'}
                                                                        </List.Header>

                                                                        <List.Description as="h6" style={{ color: 'gray' }}>
                                                                            <Icon color="teal" name="user" />
                                                                &nbsp;
                                                                            {

                                                                                el.notification && el.notification.sender && el.notification.sender.employee ?
                                                                                    el.notification.sender.employee.person.lastName + ' ' + el.notification.sender.employee.person.firstName + '    '
                                                                                    : 'eUNSA '
                                                                            }
                                                                &nbsp;
                                                                            <Icon color="teal" name="calendar alternate outline" />
                                                                &nbsp;
                                                                            {

                                                                                moment(el.notification && el.notification.timestamp).calendar(null, window.$locale === 'bs' ? {
                                                                                    sameDay: '[danas u] LT',
                                                                                    nextDay: '[sutra u] LT',
                                                                                    nextWeek: 'D. M. YYYY. [u] LT',
                                                                                    lastDay: '[jučer u] LT',
                                                                                    lastWeek: 'D. M. YYYY. [u] LT',
                                                                                    sameElse: 'D. M. YYYY. [u] LT'
                                                                                } : {
                                                                                    lastDay: '[Yesterday at] LT',
                                                                                    sameDay: '[Today at] LT',
                                                                                    nextDay: '[Tomorrow at] LT',
                                                                                    lastWeek: 'D. M. YYYY. [at] LT',
                                                                                    nextWeek: 'D. M. YYYY. [at] LT',
                                                                                    sameElse: 'D. M. YYYY. [at] LT'
                                                                                })
                                                                            }
                                                                        </List.Description>

                                                                        { this.state.openedIds.includes(el.id) && <List.Description style={{
                                                                            textAlign: 'justify', textJustify: 'inter-word', color: '#000000', paddingRight: '15px'
                                                                        }}
                                                                        > <br />{el.notification && <span dangerouslySetInnerHTML={{ __html: el.notification.text }} />}
                                                                        </List.Description>}
                                                                    </List.Content>
                                                                </Menu.Item>))}
                                                        </Menu>

                                                </div>

                                                }
                                            </div>

                                                <div style={{ paddingTop: '8px', marginTop: '4px', borderTop: '1px solid #eee', textAlign: 'center', flexShrink: 0 }}>
                                                    {this.state.hasMoreNew &&
                                                        <div style={{ color: 'gray', fontSize: '0.85em', marginBottom: '4px' }}>
                                                            {POPUP_LIMIT}+ <FormattedMessage id="common.newNotificationsMore" />
                                                        </div>
                                                    }
                                                    <Link to="/obavijesti"><FormattedMessage id="common.viewAllNotifications" /></Link>
                                                </div>

                                            </div>

                                        // </Link>
                                        }
                                        position="bottom right"
                                        on="click"
                                    /> : <p />
                            }
                        </Grid.Column>

                        {(this.props.activeRole.substr(0, 8) === 'Student:' ||
                            this.props.activeRole.substr(0, 20) === 'Diplomirani student:' ||
                            this.props.activeRole.substr(0, 16) === 'Ispisan student:' ||
                            this.props.activeRole.substr(0, 8) === 'Profesor' ||
                            this.props.activeRole.substr(0, 8) === 'Asistent')

                        &&
                            <Grid.Column><IntlConsumer>
                                {({ switchToEnglish, switchToBosnian, switchToCroatian }) => (

                                    <React.Fragment>
                                        <Dropdown icon="grey large globe icon" direction="right" pointing="top right">
                                            <Dropdown.Menu>

                                                <Dropdown.Item onClick={(this.props.activeRole.includes('Katolički') || this.props.activeRole.includes('Integrirani filozofsko-teološki studij')) ? switchToCroatian : switchToBosnian} >
                                                    <Link to={{ pathname: '/' }} style={{ color: window.$locale === 'bs' ? '#1a6aa5' : 'black' }}>
                                                        <ReactCountryFlag countryCode="ba" svg style={{ marginBottom: '3px' }} /> B/H/S </Link>
                                                </Dropdown.Item >
                                                <Dropdown.Item onClick={switchToEnglish}>
                                                    <Link to={{ pathname: '/' }} style={{ color: window.$locale === 'en' ? '#1a6aa5' : 'black' }}>
                                                        <ReactCountryFlag countryCode="gb" svg style={{ marginBottom: '3px' }} /> EN </Link>
                                                </Dropdown.Item >
                                            </Dropdown.Menu>

                                        </Dropdown>
                                    </React.Fragment>

                                )}
                            </IntlConsumer></Grid.Column> }
                        <Grid.Column>
                            <Dropdown icon="grey large user icon" direction="right" pointing="top right">
                                <Dropdown.Menu style={{ padding: 0, minWidth: '250px' }}>

                                    <Dropdown.Item
                                        text={this.props.activeRole}
                                        style={{
                                            color: '#2c8bd3',
                                            margin: 0,
                                            borderRadius: 0,
                                            padding: '12px 16px',
                                            fontWeight: 600
                                        }}
                                    />

                                    {this.state.allRoles.map((value, index) => {
                                        const el = (
                                            <Dropdown.Item
                                                key={index + 2}
                                                text={value}
                                                as={Link}
                                                to={'/u/' + index + '/'}
                                                target="_blank"
                                                style={{
                                                    margin: 0,
                                                    borderRadius: 0,
                                                    padding: '12px 16px',
                                                    display: 'block'
                                                }}
                                            />
                                        );

                                        if (index === 0) {
                                            return [
                                                <Dropdown.Divider style={{ margin: 0 }} key="divider" />,
                                                el
                                            ];
                                        }

                                        return el;
                                    })}

                                    <Dropdown.Divider style={{ margin: 0 }} />

                                    <Dropdown.Item
                                        key={1}
                                        as="a"
                                        href={keycloakLogoutUrl()}
                                        style={{
                                            margin: 0,
                                            borderRadius: 0,
                                            padding: '12px 16px'
                                        }}
                                    >
                                        <Button
                                            basic
                                            fluid
                                            color="blue"
                                            icon="refresh"
                                            style={FiltersOnStyle}
                                        >
                                            <FormattedMessage id="common.logout" />
                                        </Button>
                                    </Dropdown.Item>

                                </Dropdown.Menu>
                            </Dropdown>
                        </Grid.Column>


                    </Grid>
                </div>

                {/* <ToastContainer/> */}
            </header>
        );
    }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/Header.js